import React from 'react';

import { ListFilter } from 'lucide-react';

import { Form, Grid, Button, Tooltip } from '@mairistem/composants';

import { Section } from '@/components/Common';

interface OfficierEtatCivilProps {
  signataireNomFamille: string;
  signatairePrenom: string;
  signataireQualite: string;
  onChange: (
    _e: any,
    data: { name: string; value?: any; checked?: boolean },
  ) => void;
}

const OfficierEtatCivil = (props: OfficierEtatCivilProps) => {
  const {
    signataireNomFamille,
    signatairePrenom,
    signataireQualite,
    onChange,
  } = props;

  const handleChange = React.useCallback(
    (field: string, value: string) => {
      onChange(null, {
        name: `conventionDeclaration.${field}`,
        value,
      });
    },
    [onChange],
  );

  return (
    <Section
      data-testid="assistant-officier-etat-civil"
      title="OFFICIER D'ÉTAT CIVIL"
      style={{ minHeight: 'fit-content' }}
    >
      <Form>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={8}>
              <Form.Input
                label="Nom"
                input={{ 'data-testid': 'assistant-officier-etat-civil-nom' }}
                value={signataireNomFamille ?? ''}
                onChange={(_e, data) =>
                  handleChange('signataireNomFamille', data?.value ?? '')
                }
                action={
                  <Tooltip
                    trigger={
                      <Button
                        type="button"
                        basic
                        data-testid="assistant-officier-etat-civil-bouton-recherche"
                        icon={<ListFilter size={16} />}
                      />
                    }
                    message="Chercher un officier d'état civil"
                  />
                }
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Form.Input
                label="Prénom"
                input={{
                  'data-testid': 'assistant-officier-etat-civil-prenom',
                }}
                value={signatairePrenom ?? ''}
                onChange={(_e, data) =>
                  handleChange('signatairePrenom', data?.value ?? '')
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingTop: 0 }}>
            <Grid.Column width={8}>
              <Form.Input
                label="Grade signataire"
                input={{ 'data-testid': 'assistant-officier-etat-civil-grade' }}
                value={signataireQualite ?? ''}
                onChange={(_e, data) =>
                  handleChange('signataireQualite', data?.value ?? '')
                }
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Section>
  );
};

export default OfficierEtatCivil;
